// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\EnumType.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumItemMD } from '../../../../../../libs/com/MetaPattern/MDA/MD/EnumItemMD';

/**
 * 分布式事务协议类型枚举 枚举类
 * 分布式事务协议类型枚举
 */
export enum EnumDTPType {
  /** TCC : TCC */
  TCC = 1,
  /** MSG : MSG */
  MSG = 2,
  /** AUTOCPS : AUTOCPS */
  AUTOCPS = 4
}

/**
 * 分布式事务协议类型枚举 枚举元数据类
 * 获取枚举的元数据信息：名称、显示名称、描述、值
 */
export class EnumDTPTypeMD {
  private static items = [
    new EnumItemMD('TCC', 1, 'TCC', 'TCC'),
    new EnumItemMD('MSG', 2, 'MSG', 'MSG'),
    new EnumItemMD('AUTOCPS', 4, 'AUTOCPS', 'AUTOCPS')
  ];

  static getItem(enumItem: EnumDTPType) {
    return this.items.find(item => item.name === EnumDTPType[enumItem]);
  }

  static getItemByName(enumItemName: string) {
    return this.items.find(item => item.name === enumItemName);
  }

  static getItemByValue(enumItemValue: number) {
    return this.items.find(item => item.value === enumItemValue);
  }

  static getItems() {
    return this.items;
  }
}
